import React from 'react';
import { Icon } from '@chakra-ui/react';

export const CloseCircleIcon = (props) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104" {...props}>
      <path fill="none" d="M0 0h104v104H0z" data-name="Path 395156" opacity=".9" />
      <path
        fill="currentColor"
        d="M52 8.6A43.4 43.4 0 1 0 95.4 52 43.3 43.3 0 0 0 52 8.6zm0 78.1A34.7 34.7 0 1 1 86.7 52 34.7 34.7 0 0 1 52 86.7zm15.6-56.4L52 46 36.4 30.3l-6 6.1L45.8 52 30.3 67.6l6.1 6L52 58.2l15.6 15.6 6-6.1L58.2 52l15.6-15.6z"
        data-name="Path 395157"
      />
    </Icon>
  );
};
